var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.paginationStatus)?_c('div',{staticClass:"pagination-custom"},[_c('el-button',{staticClass:"pagination-button",attrs:{"type":"primary","plain":""},on:{"click":_vm.showMoreData}},[_vm._v("显示更多 ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }